export default __webpack_public_path__ + "static/media/Alexandra 9781408329757.85beb85a.jpg";